// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"895":"bb839da6","972":"838c28f9"}[chunkId] + ".css";
};